var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSection5Column2Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_505_2360)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 36,
    r: 34,
    fill: "#272D3A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7894 33.9583C30.4339 32.9691 30.2514 31.9261 30.2498 30.875C30.2499 29.0268 30.8036 27.221 31.8395 25.6905C32.8755 24.16 34.3461 22.9748 36.0619 22.2879C35.2176 21.8541 34.2824 21.6269 33.3332 21.625C32.2214 21.628 31.131 21.9315 30.1776 22.5034C29.2241 23.0753 28.443 23.8943 27.9169 24.8738C27.3908 25.8533 27.1394 26.9568 27.1891 28.0675C27.2388 29.1782 27.5879 30.2548 28.1994 31.1833C26.5782 31.6307 25.1478 32.596 24.1262 33.932C23.1047 35.2681 22.5482 36.9015 22.5415 38.5833C22.5465 39.5579 22.8593 40.506 23.4351 41.2923C24.011 42.0785 24.8205 42.6628 25.7482 42.9617C26.2253 39.4296 28.0275 36.2111 30.7894 33.9583Z",
    fill: "#FFCE71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8005 31.1833C51.412 30.2548 51.7611 29.1782 51.8108 28.0675C51.8605 26.9568 51.6091 25.8533 51.083 24.8738C50.5569 23.8943 49.7758 23.0753 48.8223 22.5034C47.8689 21.9315 46.7786 21.628 45.6667 21.625C44.7175 21.6269 43.7823 21.8541 42.938 22.2879C44.6538 22.9748 46.1244 24.16 47.1604 25.6905C48.1963 27.221 48.75 29.0268 48.7501 30.875C48.7485 31.9261 48.566 32.9691 48.2105 33.9583C50.9691 36.2073 52.7709 39.4197 53.2517 42.9462C54.1769 42.6482 54.9846 42.0663 55.5603 41.2831C56.1359 40.4999 56.4501 39.5553 56.4584 38.5833C56.4517 36.9015 55.8952 35.2681 54.8737 33.932C53.8522 32.596 52.4217 31.6307 50.8005 31.1833Z",
    fill: "#FFCE71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1247 34.9941C44.9282 34.1101 45.4576 33.0117 45.6487 31.8324C45.8397 30.6532 45.6841 29.4438 45.2007 28.3514C44.7174 27.2589 43.9271 26.3303 42.926 25.6785C41.9249 25.0267 40.756 24.6797 39.5613 24.6797C38.3667 24.6797 37.1978 25.0267 36.1967 25.6785C35.1955 26.3303 34.4053 27.2589 33.9219 28.3514C33.4386 29.4438 33.283 30.6532 33.474 31.8324C33.6651 33.0117 34.1945 34.1101 34.998 34.9941C33.1285 35.8521 31.5432 37.2266 30.4288 38.9555C29.3144 40.6845 28.7174 42.6959 28.708 44.7528C28.708 45.9795 29.1953 47.1559 30.0626 48.0232C30.93 48.8906 32.1064 49.3778 33.333 49.3778H45.6663C46.893 49.3778 48.0694 48.8906 48.9367 48.0232C49.8041 47.1559 50.2913 45.9795 50.2913 44.7528C50.2929 42.7092 49.7142 40.7072 48.6225 38.9796C47.5309 37.252 45.9711 35.8699 44.1247 34.9941Z",
    fill: "#FFCE71"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_505_2360",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_505_2360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_505_2360",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection5Column2Icon);
export default __webpack_public_path__ + "static/media/section-5-column-2-icon.f03f63c203b8fb31c716876b2c633b68.svg";
export { ForwardRef as ReactComponent };